// This allows invalidate all caches in browser tha are get with fetches

import {browserGetCookie, browserSetCookie} from "./browser.js";
import CONFIG from "./../config.json";

let _cacheTime = null;

function cacheSetCacheTime(value)
{
    _cacheTime = value;
}

function cacheGetCacheTime()
{
    return(_cacheTime);
}

function caheIsQuickReload() {
    let lastUnloadTime = browserGetCookie("lastUnloadTime");
    let lastUnloadURL = browserGetCookie("lastUnloadURL");
    let currentURL = window.location.href;
    let now = new Date().getTime();
    let ret = false;

    if (lastUnloadTime && lastUnloadURL === currentURL) {
        let timeDifference = now - lastUnloadTime;
        if (timeDifference < 5000) {
            ret = true;
        }
    }

    browserSetCookie("lastUnloadTime", now, 1);
    browserSetCookie("lastUnloadURL", currentURL, 1);

    return ret;
}

function IfQuickReloadFlushEverything()
{
    let time;
    if (caheIsQuickReload())
    {
        try {
            fetch(`${CONFIG.posters_api_url}/flush`);
            fetch("/flush");
        } finally {
            time = new Date().getTime();
            browserSetCookie("cacheTime", time, 1);
        }
    } else
    {
        time = browserGetCookie("cacheTime");
    }
    cacheSetCacheTime(time);
}

export {IfQuickReloadFlushEverything, cacheGetCacheTime}
